import { Helmet } from 'react-helmet-async';

export const LocalBusinessSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Duo a Color",
        "alternateName": ["duoacolor", "Duoacolor", "duo a color"],
        "description": "Duo a Color - Estudio de diseño artesanal especializado en punch needle y pintura personalizada. Creamos totebags, cojines y accesorios únicos en España.",
        "url": "https://duoacolor.com",
        "logo": "https://duoacolor.com/img/LogoDuoaColor512.png",
        "image": "https://duoacolor.com/img/LogoDuoaColor512.png",
        "priceRange": "€€",
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "ES"
        },
        "areaServed": "ES",
        "knowsAbout": ["punch needle", "arte textil", "diseño personalizado", "totebags artesanales"],
        "sameAs": [
            "https://www.instagram.com/duoacolor",
            "https://www.tiktok.com/@duoacolor"
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const ProductSchema = ({ product }) => {
    if (!product) return null;

    const getImageUrl = (images) => {
        if (!images || images.length === 0) return '';
        const firstImage = images[0];
        const imagePath = typeof firstImage === 'string' ? firstImage : firstImage.src;
        return `https://duoacolor.com/img${imagePath}`;
    };

    const schema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.name,
        "description": product.description,
        "image": getImageUrl(product.images),
        "offers": {
            "@type": "Offer",
            "price": product.price,
            "priceCurrency": "EUR",
            "availability": "https://schema.org/InStock"
        },
        "brand": {
            "@type": "Brand",
            "name": "Duo a Color"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const WebSiteSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Duo a Color",
        "alternateName": ["duoacolor", "Duoacolor", "duo a color"],
        "url": "https://duoacolor.com",
        "publisher": {
            "@type": "Organization",
            "name": "Duo a Color",
            "url": "https://duoacolor.com"
        }
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const OrganizationSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Duo a Color",
        "alternateName": ["duoacolor", "Duoacolor", "duo a color"],
        "url": "https://duoacolor.com",
        "logo": "https://duoacolor.com/img/LogoDuoaColor512.png",
        "image": "https://duoacolor.com/img/LogoDuoaColor512.png",
        "sameAs": [
            "https://www.instagram.com/duoacolor",
            "https://www.tiktok.com/@duoacolor"
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

export const SiteNavigationSchema = () => {
    const navigationItems = [
        { name: "Inicio", url: "https://duoacolor.com/" },
        { name: "Nuestra Esencia", url: "https://duoacolor.com/our-essence" },
        { name: "Crea Tu Historia", url: "https://duoacolor.com/create-your-story" },
        { name: "Historias Vividas", url: "https://duoacolor.com/lived-stories" },
        { name: "Listos para Ti", url: "https://duoacolor.com/listos-para-ti" },
        { name: "Contacto", url: "https://duoacolor.com/contact" }
    ];

    const schema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": navigationItems.map((item, index) => ({
            "@type": "SiteNavigationElement",
            "position": index + 1,
            "name": item.name,
            "url": item.url
        }))
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};
